<template>
  <div class="valid">
    <div class="valid-text">
      {{ $t('checkout.ovoPhoneNumber') }}
    </div>
    <q-input
      v-model="_phone"
      type="tel"
      class="valid-input"
      outlined
      no-error-icon
      hide-bottom-space
      bottom-slots
      bg-color="white"
      mask="#"
      reverse-fill-mask
      :error-message="check.msg"
      :error="check.status"
      @input="$emit('done')"
    >
      <template #error>
        <div>
          {{ check.msg }}
        </div>
      </template>
    </q-input>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'phone',
    event: 'phone_change',
  },
  props: {
    phone: {
      type: String,
      default: '',
    },
  },
  data() {
    return {};
  },
  computed: {
    _phone: {
      get() {
        return this.phone;
      },
      set(v) {
        this.$emit('phone_change', v);
      },
    },
    check() {
      const { phone } = this;
      if (phone.length > 0) {
        if (new RegExp('^0.*$').test(phone) && phone.length >= 9) {
          return { status: false };
        }
        if (!new RegExp('^0.*$').test(phone)) {
          return { msg: this.$t('checkout.ovoErrMsg1'), status: true };
        }
        if (phone.length < 9) {
          return { msg: this.$t('checkout.ovoErrMsg2'), status: true };
        }
      }
      return { status: false };
    },
  },
};
</script>

<style lang="scss" scoped>
.valid {
  font-family: Montserrat;
  &-text {
    color: #6b7280;
    font-size: 12px;
    line-height: 120%;
  }
  &-input {
    margin-top: 4px;
    :deep(.q-field__control) {
      height: 42px;
      border-radius: 8px;
    }
  }
}
</style>
